import { Middleware } from 'redux';
import { showAlert } from '../actions';
import Alert from '../../data/Alert';

const Sentry = (window as any).Sentry;

const handler: Middleware =
  (store: any) => (next: Function) => (action: any) => {
    try {
      return next(action);
    } catch (err) {
      console.error('Caught an exception!', err);
      if (Sentry) {
        Sentry.withScope((scope: any) => {
          scope.setTag('action', action.type);
          Sentry.captureException(err);
        });
      }
      next(showAlert(new Alert(err.name, err.message)));
      throw err;
    }
  };

export default handler;



// WEBPACK FOOTER //
// ./src/state/side-effects/sentryCapturing.ts